module.exports = __webpack_public_path__ + "static/media/quanto-falta-sonho.ddde45fa.jpg";